import React from "react";


const Aboutus = () => {
  return (
    <>
      <section className="about py-80">
        <div className="container container-lg">
          <div className="text-center mb-64">
            <h2 className="mb-24">About Us</h2>
            <p className="text-gray-600">
              “Airdeal India” – The name is synonymous for direct selling in
              India, with the legacy of loyal consumers in every corner of the
              country.
            </p>
          </div>

          <div className="row gy-4">
            <div className="col-lg-12">
              <div className="border border-gray-100 rounded-16 p-32">
                <p className="mb-24 text-gray-700">
                  With its success, the main objective of the organization has
                  always been to transform the lives of people by providing them
                  an opportunity to enjoy financial independence, empower them
                  socially, enabling them with relevant skills and live a
                  blissful life.
                </p>

                <p className="mb-24 text-gray-700">
                  In our mission to make India Healthy & Wealthy, we have
                  developed a range of daily consumable products in FMCG – Food
                  & Non-Food (Household, Home care, Personal care, Eatable and
                  Edible products), Health & Nutrition, Fashion & Accessories,
                  Stationary & Travel accessories, footwear categories that are
                  used from “Good Morning to Good Night”.
                </p>

                <p className="mb-24 text-gray-700">
                  The dream of the founder of Airdeal India is to transform
                  lives followed by a very holistic approach of developing each
                  and every product keeping in mind the main motto of “health as
                  the vital factor” and keeping the price of every product at
                  “arm's length for every household of the country”.
                </p>

                <p className="mb-24 text-gray-700">
                  The quality of products is ensured with the sourcing of finest
                  ingredients from the best manufacturers across the world and
                  State-of-Art technology and highly advanced plant & machinery.
                </p>

                <p className="mb-24 text-gray-700">
                  “Health & Innovation” – Our highly skilled product Development
                  & Sourcing team have been working tirelessly adding many more
                  wonderful products & categories in this journey.
                </p>

                <p className="mb-24 text-gray-700">
                  Holistic approach in the overall development of direct sellers
                  associated with the company has resulted in prodigious trust
                  in Airdeal India network, which has a wide and deep reach
                  across India from Kargil to Kanyakumari and Kutch to
                  Kaziranga.
                </p>

                <p className="mb-24 text-gray-700">
                  This delivery system is backed up with a robust ERP system,
                  which also keeps each and every Direct Seller updated with
                  real-time smart information of their business activities with
                  Airdeal India.
                </p>

                <p className="mb-24 text-gray-700">
                  With time, Airdeal India is exploring new avenues under its
                  headship qualities in the E-commerce industry. Complete range
                  of exclusive products is available on E-commerce platform
                  supported by most modern technology.
                </p>

                <p className="mb-24 text-gray-700">
                  Airdeal India’s latest app facilitates the users to operate
                  their whole business at their fingertips.
                </p>

                <div className="bg-main-50 rounded-16 p-24 mt-40">
                  <h4 className="mb-20 text-main-600">
                    FOUNDER VISION: PROSPERITY OF ALL WITH VALUES
                  </h4>

                  <p className="text-gray-700 mb-0">
                    “The Ultimate Pride” comes from the unmatchable world-class
                    value based education system that transforms the lives of
                    the people. Our education system helps the people to
                    identify, develop and enhance their actual potential to
                    achieve new heights in life. Our unique system educates and
                    motivates them to live a healthy life with a strong bond
                    with society and the nation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Aboutus;
